/* Polsk katalog for locale-closing-focused-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'clo.focus.finalConfirmation': 'Sprawdziłem podstawę, zdarzenia w kapitale własnym, zdarzenia po dniu bilansowym i kontynuację działalności. Wszystkie niezbędne księgowania i oceny są wyjaśnione. Zatwierdzam zamknięcie roku. Osoba zatwierdzająca i czas zostaną zapisane w historii.',
  'clo.focus.approve': 'Zatwierdź',
  'clo.focus.startYear': 'Rok rozpoczęcia księgowości',
  'clo.focus.bankSetupMissing': 'Wprowadź datę rozpoczęcia i udokumentowane saldo początkowe w ustawieniach konta poniżej. Wpisz 0, jeśli saldo wynosiło zero.',
  'clo.focus.bankStatements': 'Brakuje wyciągów bankowych za okresy',
  'clo.focus.bankUnsettled': 'Okresy do uzgodnienia',
  'clo.focus.bankDifferences': 'Różnice sald trzeba wyjaśnić w uzgodnieniu bankowym.',
  'clo.focus.bankUnconfigured': 'Utwórz rachunki bankowe z właściwym kontem księgowym dla tych zaksięgowanych sald',
  'clo.focus.reconcile': 'Dokończ uzgadnianie',
  'clo.focus.restore': 'Przywróć rozmiar',
  'clo.focus.fullscreen': 'Pełny ekran',
  'clo.focus.notCalculated': 'Nie obliczono',
  'clo.focus.taxScope': 'Ustal reżim podatkowy',
  'clo.focus.rateHelp': 'Zwykły norweski podatek od osób prawnych wynosi 22 % od 2019 r. Potwierdź reżim podatkowy, zanim obliczenie będzie mogło zostać zatwierdzone. Podatek od działalności finansowej i reżimy szczególne wymagają osobnej oceny.',
  'clo.focus.industry': 'Reżim podatkowy',
  'clo.focus.ordinary': 'Zwykły reżim podatkowy',
  'clo.focus.special': 'Reżim szczególny – wymaga oceny',
  'clo.focus.finance': 'Podlega podatkowi od działalności finansowej',
  'clo.focus.priorLoss': 'Strata do przeniesienia z lat ubiegłych (potwierdź także 0)',
  'clo.focus.updateCalculation': 'Zapisz i oblicz',
  'clo.focus.taxCalculation': 'Jak obliczany jest podatek',
  'clo.focus.resultBeforeTax': 'Wynik przed opodatkowaniem',
  'clo.focus.permanent': '+ Różnice trwałe (netto)',
  'clo.focus.temporaryChange': '− Zmiana różnic przejściowych',
  'clo.focus.lossApplied': '− Wykorzystana strata z lat ubiegłych',
  'clo.focus.taxable': '= Podstawa opodatkowania',
  'clo.focus.rate': 'Stawka podatku',
  'clo.focus.resolveRate': 'Ustal reżim podatkowy powyżej',
  'clo.focus.payable': '= Podatek należny',
  'clo.focus.lossRemaining': 'Strata do przeniesienia',
  'clo.focus.deferredTax': 'Podatek odroczony / aktywo podatkowe',
  'clo.focus.temporary': 'Różnice przejściowe',
  'clo.focus.unrecognized': 'Nieujęte aktywo podatkowe (podstawa)',
  'clo.focus.deferredBasis': 'Podstawa podatku odroczonego',
  'clo.focus.deferredAmount': 'Podatek odroczony / aktywo podatkowe',
  'clo.focus.postingApproval': 'Zatwierdź obliczenie i księgowanie zamykające',
  'clo.focus.postingHelp': 'Zatwierdzenie potwierdza, że sprawdziłeś podstawę opodatkowania, różnice i stratę do przeniesienia. Podatek należny i ewentualna zmiana podatku odroczonego zostaną zaksięgowane przy zamknięciu roku obrotowego. Kwoty już zaksięgowane są uwzględniane w księgowaniu zamykającym.',
  'clo.focus.postingAccounts': 'Obliczony podatek należny: Wn 8300 / Ma 2500',
  'clo.focus.reviewRequired': 'Reżim podatkowy lub szczególne okoliczności podatkowe trzeba wyjaśnić przed zatwierdzeniem.',
  'clo.focus.unsaved': 'Po zmianach zapisz i oblicz, zanim zatwierdzisz.',
  'clo.focus.editDifferences': 'Edytuj różnice i specyfikacje',
  'clo.checklist.custom.mappedDetail': 'Żadne konto nie jest pozbawione powiązania ze standardowym planem kont Plumme. Zaimportowane konta są sprawdzane, gdy zostaną włączone do planu kont. Nie jest to kontrola całego powiązania ze skattemelding.',
  'clo.priorYear.closedDetail': 'Rok obrotowy {{year}} jest zamknięty.',
  'clo.priorYear.noActivity': 'W Plumme nie zarejestrowano danych księgowych za {{year}}. Sam rok rozpoczęcia nie przesądza, czy poprzedni rok trzeba zamknąć.',
});
